import type { OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {CookieService, SocialEmbedsService} from "@candyland/angular/shared/util-nmo";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  constructor(private cookieService: CookieService, private socialEmbeds: SocialEmbedsService){}

  ngOnInit() {
    // Check for Data-Cookie-Social-Consent
    if (this.cookieService.get('tt-social-consent') === 'consentIsGiven') {
      this.socialEmbeds.setConsentAngularWide(true);
    }
  }
}
